import { useAuth0 } from '@auth0/auth0-react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

/**
 * Auth0 callback page — Auth0Provider obsługuje URL parsing automatically,
 * `onRedirectCallback` (w Auth0ProviderWithRouter) navigates do appState.returnTo.
 *
 * Tutaj tylko spinner — user zobaczy go przez ~50ms zanim onRedirectCallback wystrzeli.
 */
export const Route = createFileRoute('/_public/callback')({
  component: CallbackPage,
});

function CallbackPage() {
  const { error } = useAuth0();
  const { t } = useTranslation();

  if (error) {
    return (
      <main className="flex min-h-dvh items-center justify-center p-8">
        <div role="alert" className="max-w-lg rounded-lg border border-[var(--color-border-strong)] bg-[var(--color-bg-elevated)] p-8 shadow-sm">
          <h1 className="mb-2 text-xl font-bold text-[var(--color-danger)]">{t('common.error')}</h1>
          <p className="text-sm text-[var(--color-text-secondary)]">{error.message}</p>
        </div>
      </main>
    );
  }

  return (
    <main className="flex min-h-dvh items-center justify-center">
      <div className="text-center">
        <div className="mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4 border-[var(--color-border)] border-t-[var(--color-accent)]" />
        <p className="text-sm text-[var(--color-text-secondary)]">{t('auth.callback')}</p>
      </div>
    </main>
  );
}
